const initialState = {
    data: [],
    isFetching: false,
    error: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case "GET_CLIENTS":
            return {
                ...state,
                isFetching: true,
                error: false
            }
        case "FETCH_CLIENTS":
            return {
                ...state,
                isFetching: false,
                data: action.payload
            }
        case "ERROR_CLIENTS":
            return {
                ...state,
                isFetching: false,
                error: true
            }
        default:
            return state
    }

}
